import { IconWrapper } from '../runtime';
export default IconWrapper('calendar', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M1.75 6.74969H14.25M4.75 2.74969V0.749695M11.2522 2.74969V0.749695M3.25 14.2497H12.75C13.5784 14.2497 14.25 13.5781 14.25 12.7497V4.24969C14.25 3.42127 13.5784 2.74969 12.75 2.74969H3.25C2.42157 2.74969 1.75 3.42127 1.75 4.2497V12.7497C1.75 13.5781 2.42157 14.2497 3.25 14.2497Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});